import { FileSearch } from 'lucide-react';
import type { Question } from '../../data/schemas';
import type { ClusterResult } from '../../types/result';
import { ClusterDetailContent } from './ClusterDetailContent';
import { SectionHeading } from './SectionHeading';

interface ClusterDetailSectionProps {
  clusters: readonly ClusterResult[];
  questions: readonly Question[];
  showWeightingDetails: boolean;
}

/** Ausführliche Cluster-Analyse (Abschnitt 16.6, Reihenfolge Position 10 in Abschnitt 23). */
export function ClusterDetailSection({
  clusters,
  questions,
  showWeightingDetails,
}: ClusterDetailSectionProps) {
  return (
    <section className="stack">
      <SectionHeading icon={FileSearch}>Ausführliche Analyse je Bereich</SectionHeading>
      {clusters.map((cluster) => (
        <div
          key={cluster.clusterId}
          id={`cluster-detail-${cluster.clusterId}`}
          className="card stack"
        >
          <ClusterDetailContent
            cluster={cluster}
            questions={questions}
            showWeightingDetails={showWeightingDetails}
          />
        </div>
      ))}
    </section>
  );
}
